import Base from '~/components/academies/common/academy-breadcrumb';

interface AcademyBreadcrumbsProps {
  title: string;
  linkColor: string;
  padding: string;
  hidden: boolean;
  breadcrumbs: { links: Array<string>[] };
}

export const AcademyBreadcrumb = ({ title, linkColor, padding, breadcrumbs, hidden }: AcademyBreadcrumbsProps) => {
  // add fallback for now
  const items = breadcrumbs?.links || [
    {
      linkText: 'Home',
      link: '/',
    },
    {
      linkText: title,
    },
  ];

  if (hidden || !items || items?.length === 0) {
    return null;
  }

  return <Base links={items} linkColor={linkColor} padding={padding} />;
};
